import type { CreateRoomRequest, CreateRoomResponse } from '@chipless/shared';
import { API_BASE } from './env.js';

/** ルーム作成のみ HTTP。それ以外はすべて WebSocket（design 7.3）。 */

export async function createRoom(request: CreateRoomRequest): Promise<CreateRoomResponse> {
  const res = await fetch(`${API_BASE}/api/rooms`, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(request),
  });

  if (!res.ok) {
    const detail: unknown = await res.json().catch(() => null);
    const message =
      typeof detail === 'object' && detail !== null && 'message' in detail
        ? String((detail as { message: unknown }).message)
        : `ルームの作成に失敗した（${res.status}）`;
    throw new Error(message);
  }

  return (await res.json()) as CreateRoomResponse;
}
